
import React from 'react';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';
import ScrollReveal from '../ui/ScrollReveal';
import { Link } from 'react-router-dom';

const About = () => {
  const values = [
    'Excellence in every detail',
    'Transparency throughout the process',
    'Client-centered approach',
    'Creative problem solving',
    'Continuous innovation'
  ];

  return (
    <section className="section-padding bg-astrem-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <ScrollReveal>
              <span className="inline-block px-3 py-1 bg-astrem-gray-200 text-astrem-gray-800 rounded-full text-sm font-medium mb-4">
                About Astrem
              </span>
            </ScrollReveal>
            
            <ScrollReveal delay={100}>
              <h2 className="text-3xl md:text-4xl font-display font-medium mb-6">
                Creative Solutions for Modern Challenges
              </h2>
            </ScrollReveal>
            
            <ScrollReveal delay={200}>
              <p className="text-astrem-gray-600 mb-6">
                Founded by Evan in Baton Rouge, Louisiana, Astrem is a comprehensive marketing, technology, and creative consulting company dedicated to finding innovative solutions and crafting exceptional experiences for our clients.
              </p>
            </ScrollReveal>
            
            <ScrollReveal delay={300}>
              <p className="text-astrem-gray-600 mb-8">
                We partner with businesses, organizations, and individuals across the United States to create professional, high-quality products and services that help them achieve their goals and elevate their digital presence.
              </p>
            </ScrollReveal>
            
            <ScrollReveal delay={400}>
              <div className="space-y-3 mb-8">
                {values.map((value, index) => (
                  <div key={index} className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-astrem-black mr-3 mt-0.5 flex-shrink-0" />
                    <p className="text-astrem-gray-700">{value}</p>
                  </div>
                ))}
              </div>
            </ScrollReveal>
            
            <ScrollReveal delay={500}>
              <Button asChild className="bg-astrem-black hover:bg-astrem-gray-800 text-white rounded-full px-6">
                <Link to="/about">Learn More About Us</Link>
              </Button>
            </ScrollReveal>
          </div>

          <div className="order-1 lg:order-2">
            <ScrollReveal className="relative">
              <div className="relative rounded-2xl overflow-hidden">
                <img 
                  src="https://app.milanote.com/media/p/images/1TZlWZ1uaXLgcz/ZkG/Astrem%20-%20Evan%20Lifestyle%20Collateral%20-%20February%202025%20%287%20of%2055%29%20V2.jpg" 
                  alt="Astrem creative team at work" 
                  className="w-full h-auto rounded-2xl object-cover aspect-[4/3] shadow-xl"
                />
                <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-black/50 to-transparent"></div>
              </div>
              
              {/* Abstract design element */}
              <div className="absolute -bottom-6 -right-6 w-48 h-48 rounded-full bg-astrem-gray-100 -z-10"></div>
              <div className="absolute -top-6 -left-6 w-24 h-24 rounded-full border-4 border-astrem-gray-300 -z-10"></div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
